// extracted by css-extract-rspack-plugin
export default {"wrap":"wrap-XO2Jx8","indicator":"indicator-CJ5R0r","icon":"icon-KwxrVT","label":"label-AZ_JwH","expand":"expand-WHcLPI","explanation":"explanation-bENLfY","pulse":"pulse-qMmg6d"};